export interface IContractDocument {
  id: string;
  documentName: string;
  documentSize: number;
  documentType: string;
  uploadedDate: Date | string | number;
  files: File[];
}

export interface ContractFormData {
  contractNumber: string;
  contractName: string;
  contractDescription: string;
  scac: string;
  referenceNumber: string;
  effectiveDate: Date | string | number;
  expirationDate: Date | string | number;
  currency: string;
  renewalReminder: number;
  documents: IContractDocument[] | any[];
}

export interface IContractStore {
  contracts: ContractFormData[];
  showContractPopup: boolean;
  lastCreatedContract: ContractFormData | null;
}

export const initialContractState: IContractStore = {
  contracts: [],
  showContractPopup: false,
  lastCreatedContract: null
};
